/*
infiniteslide.js v2
version: 2.0.1
Author: T.Morimoto

Copyright 2017, T.Morimoto
* Free to use and abuse under the MIT license.
* http://www.opensource.org/licenses/mit-license.php

https://github.com/woodroots/infiniteSlidev2
*/

($ => {
    $(window).on("load", () => {
        window.loaded = true;
    });

    $(() => {
        $.fn.infiniteSlide = function(options) {
            //option
            const settings = $.extend(
                {
                    speed: 100,
                    direction: "left",
                    pauseOnHover: true,
                    responsive: false,
                    clone: 1,
                    marginRight: 10
                },
                options
            );

            const setCss = (obj, direction, marginRight) => {
                $(obj)
                    .wrap('<div class="infiniteSlide_wrap"></div>')
                    .parent()
                    .css({
                        overflow: "hidden"
                    });

                let d;

                if (direction === "up" || direction === "down") {
                    d = "column";
                } else {
                    d = "row";
                }

                $(obj)
                    .css({
                        display: "flex",
                        flexWrap: "nowrap",
                        alignItems: "center",
                        "-ms-flex-align": "center",
                        flexDirection: d
                    })
                    .children()
                    .css({
                        flex: "none",
                        display: "block",
                        marginRight: marginRight
                    });
            };

            const setClone = (obj, clone) => {
                const $clone = $(obj)
                    .children()
                    .clone()
                    .addClass("infiniteSlide_clone");
                let i = 1;

                while (i <= clone) {
                    $clone.clone().appendTo($(obj));
                    i++;
                }
            };

            const getWidth = obj => {
                let w = 0;

                $(obj)
                    .children(":not(.infiniteSlide_clone)")
                    .each(function(key, value) {
                        w = w + $(this).outerWidth(true);
                    });
                return w;
            };

            const getHeight = obj => {
                let h = 0;

                $(obj)
                    .children(":not(.infiniteSlide_clone)")
                    .each(function(key, value) {
                        h = h + $(this).outerHeight(true);
                    });
                return h;
            };

            const getSpeed = (l, s) => {
                return l / s;
            };

            const getNum = (obj, direction) => {
                let num;

                if (direction === "up" || direction === "down") {
                    num = getHeight(obj);
                } else {
                    num = getWidth(obj);
                }
                return num;
            };

            const getTranslate = (num, direction) => {
                let j;

                if (direction === "up" || direction === "down") {
                    j = "0,-" + num + "px,0";
                } else {
                    j = "-" + num + "px,0,0";
                }
                return j;
            };

            const setAnim = (obj, id, direction, speed) => {
                const num = getNum(obj, direction);

                if (direction === "up" || direction === "down") {
                    $(obj)
                        .parent(".infiniteSlide_wrap")
                        .css({
                            height: num + "px"
                        });
                }

                let i = getTranslate(num, direction);

                $(obj).attr("data-style", "infiniteSlide" + id);

                const css =
                    "@keyframes infiniteSlide" +
                    id +
                    "{" +
                    "from {transform:translate3d(0,0,0);}" +
                    "to {transform:translate3d(" +
                    i +
                    ");}" +
                    "}";
                $("<style />")
                    .attr("id", "infiniteSlide" + id + "_style")
                    .html(css)
                    .appendTo("head");

                let reverse;

                if (direction === "right" || direction === "down") {
                    reverse = " reverse";
                } else {
                    reverse = "";
                }

                $(obj).css({
                    animation:
                        "infiniteSlide" +
                        id +
                        " " +
                        getSpeed(num, speed) +
                        "s linear 0s infinite" +
                        reverse
                });
            };

            const setStop = obj => {
                $(obj)
                    .on("mouseenter", () => {
                        $(this).css({
                            animationPlayState: "paused"
                        });
                    })
                    .on("mouseleave", () => {
                        $(this).css({
                            animationPlayState: "running"
                        });
                    });
            };

            const setResponsive = (obj, direction) => {
                const num = getNum(obj, direction);
                return getTranslate(num, direction);
            };

            return this.each(function(key, value) {
                const $this = $(this);
                const num =
                    Date.now() + Math.floor(10000 * Math.random()).toString(16);

                if (settings.pauseOnHover === true) {
                    setStop($this);
                }

                const _onload = () => {
                    setCss($this, settings.direction, settings.marginRight);
                    setClone($this, settings.clone);
                    setAnim($this, num, settings.direction, settings.speed);

                    if (settings.responsive) {
                        $(window).on("resize", () => {
                            const i = setResponsive($this, settings.direction);
                            const styleId = $this.attr("data-style");
                            const styleEl = $("#" + styleId + "_style");
                            const styleHTML = styleEl.html();

                            const styleHTML_new = styleHTML.replace(
                                /to {transform:translate3d\((.*?)\)/,
                                "to {transform:translate3d(" + i + ")"
                            );
                            styleEl.html(styleHTML_new);
                        });
                    }
                };

                if (window.loaded) {
                    _onload();
                } else {
                    $(window).on("load", _onload);
                }
            });
        };
    });
})(jQuery);
